import * as React from 'react';

import {EmptyAddCard} from 'shells/card/empty-add-card';
import {EditThickerIcon} from 'shells/icon/svg/edit-thicker-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {ListViewLoadingBars} from 'shells/list-view/list-view-loading-bars';

import type {PreferenceCenterAudience as Audience} from 'nutshell-graphql-types';

import {PublicAudienceListCard} from '../audiences/public-audience-list-card';

import styles from './public-audiences-list.module.css';

type Props = {
    audiences: Audience[];
    onEditAudience: (audience: Audience) => void;
    onAddAudience: () => void;
    onRemoveAudience: (audience: Audience) => void;
    isLoading: boolean;
};

export function PublicAudiencesList(props: Props) {
    if (props.isLoading) {
        return (
            <ListViewLoadingBars
                numBars={3}
                spacing={12}
                barHeight={162}
                padding={0}
                backgroundColor='offWhite'
            />
        );
    }

    return (
        <>
            <StackLegacy spacing={12}>
                <div className={styles['scroll-container']}>
                    <StackLegacy spacing={12}>
                        {props.audiences.map((audience) => {
                            const actionMenuOptions = [
                                {
                                    label: 'Edit',
                                    handleSelect: () => {
                                        props.onEditAudience(audience);
                                    },
                                    icon: <EditThickerIcon wrapWithDiv={false} size={18} />,
                                },
                                {
                                    label: 'Remove from preference center',
                                    variant: 'destructive',
                                    handleSelect: () => {
                                        props.onRemoveAudience(audience);
                                    },
                                },
                            ];

                            return (
                                <PublicAudienceListCard
                                    key={audience.id}
                                    name={audience.name}
                                    subscribersCount={audience.membershipStats.totalCount.value}
                                    deletedTime={audience.deletedTime}
                                    htmlUrlPath={audience.htmlUrlPath}
                                    // @ts-expect-error
                                    actionMenuOptions={actionMenuOptions}
                                    publicName={audience.publicName}
                                    publicDescription={audience.publicDescription || ''}
                                />
                            );
                        })}
                    </StackLegacy>
                </div>
                <EmptyAddCard
                    isDisabled={props.audiences.length >= 10}
                    onClick={props.onAddAudience}
                    text={`Add another audience (${props.audiences.length}/10)`}
                    background='off-white'
                    size='small'
                    withoutIcon={true}
                    height={61}
                />
            </StackLegacy>
        </>
    );
}
